'use client';

import { useEffect } from 'react';

/**
 * 개발 환경에서 GA4 traffic_type을 'developer'로 설정합니다.
 * 이렇게 하면 회사 IP에서도 Internal Traffic 필터에 걸리지 않고
 * DebugView에서 이벤트를 확인할 수 있습니다.
 */
export function GADevTrafficType() {
  useEffect(() => {
    if (window.gtag) {
      if (process.env.NEXT_PUBLIC_IS_LOCAL === 'local') {
        // traffic_type을 'developer'로 설정하여 Internal Traffic 필터 우회
        window.gtag('set', { traffic_type: 'developer' });
      }
    }
  }, []);

  return null;
}
